document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.lb-section');
  if (!root) return;

  /* Gallery + lightbox */
  var mainImg = root.querySelector('.lb-gallery-main img');
  var thumbs = root.querySelectorAll('.lb-thumbs img');
  var dots = root.querySelectorAll('.lb-gallery-dots span');
  var lightbox = root.querySelector('.lb-lightbox');
  var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
  var galleryImages = Array.prototype.map.call(thumbs, function (t) { return t.getAttribute('data-full') || t.src; });
  var current = 0;

  function setActive(i) {
    current = (i + galleryImages.length) % galleryImages.length;
    if (mainImg) mainImg.src = galleryImages[current];
    thumbs.forEach(function (t, idx) { t.classList.toggle('active', idx === current); });
    dots.forEach(function (d, idx) { d.classList.toggle('active', idx === current); });
  }
  thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { setActive(idx); }); });
  if (mainImg) mainImg.addEventListener('click', function () { openLightbox(current); });

  function openLightbox(i) {
    if (!lightbox) return;
    current = i;
    lightboxImg.src = galleryImages[current];
    lightbox.classList.add('open');
  }
  function closeLightbox() { if (lightbox) lightbox.classList.remove('open'); }
  if (lightbox) {
    lightbox.querySelector('.lb-lightbox-close').addEventListener('click', closeLightbox);
    lightbox.querySelector('.lb-lightbox-prev').addEventListener('click', function () { setActive(current - 1); lightboxImg.src = galleryImages[current]; });
    lightbox.querySelector('.lb-lightbox-next').addEventListener('click', function () { setActive(current + 1); lightboxImg.src = galleryImages[current]; });
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
  }

  /* Pack selector */
  var packs = root.querySelectorAll('.lb-pack');
  packs.forEach(function (p) {
    p.addEventListener('click', function () {
      packs.forEach(function (o) { o.classList.remove('selected'); });
      p.classList.add('selected');
      var variantInput = root.querySelector('#lb-selected-variant');
      if (variantInput) variantInput.value = p.getAttribute('data-variant-id');
      var priceInput = root.querySelector('.lb-price-now');
      var compareInput = root.querySelector('.lb-price-compare');
      var offerLine = root.querySelector('.lb-offer-line');
      var offerWas = root.querySelector('.lb-offer-was');
      if (priceInput) priceInput.textContent = p.getAttribute('data-price-fmt');
      var cmp = p.getAttribute('data-compare-fmt');
      if (compareInput) {
        if (cmp) { compareInput.textContent = cmp; compareInput.style.display = ''; }
        else { compareInput.style.display = 'none'; }
      }
      if (offerLine) {
        offerLine.style.display = cmp ? '' : 'none';
        if (cmp && offerWas) offerWas.textContent = 'luego ' + cmp;
      }
      broadcastVariantChange(p.getAttribute('data-variant-id'));
    });
  });

  /* Push the selected variant into Shopify's standard variant inputs/events so
     apps embedded lower on the page (e.g. Releasit COD Form) pick it up automatically. */
  function broadcastVariantChange(variantId) {
    if (!variantId) return;
    document.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (el) {
      if (el.value !== String(variantId)) {
        el.value = variantId;
        el.dispatchEvent(new Event('change', { bubbles: true }));
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
    var detail = { variant: { id: Number(variantId) }, variantId: Number(variantId) };
    ['variant:change', 'variant:changed', 'productVariantChange', 'on:variant:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
    });
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  }

  /* Accordions */
  root.querySelectorAll('.lb-acc-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.lb-acc-item');
      var panel = item.querySelector('.lb-acc-panel');
      var isOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.lb-acc-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.lb-acc-panel').style.maxHeight = null;
      });
      if (!isOpen) {
        item.classList.add('open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* Testimonial carousel autoplay */
  var track = root.querySelector('.lb-testi-track');
  if (track) {
    var testiDots = root.querySelectorAll('.lb-testi-dots span');
    var cardWidth = function () { return track.querySelector('.lb-testi-card').offsetWidth + 12; };
    var autoTimer = setInterval(function () {
      var next = track.scrollLeft + cardWidth();
      if (next >= track.scrollWidth - track.clientWidth - 5) next = 0;
      track.scrollTo({ left: next, behavior: 'smooth' });
    }, 4000);
    ['touchstart', 'mousedown'].forEach(function (ev) {
      track.addEventListener(ev, function () { clearInterval(autoTimer); }, { passive: true });
    });
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / cardWidth());
      testiDots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    });
  }

  /* Offer countdown — resets every 24h */
  var countdownEl = root.querySelector('.lb-countdown');
  if (countdownEl) {
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var diff = Math.max(0, end - now);
      var h = String(Math.floor(diff / 3600000)).padStart(2, '0');
      var m = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      var s = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      countdownEl.textContent = h + ':' + m + ':' + s;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* Sticky bar scroll to purchase */
  var stickyBtn = root.querySelector('.lb-sticky-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var target = root.querySelector('.lb-cod-wrap') || root.querySelector('.lb-cta-fallback');
      if (target) target.scrollIntoView({ block: 'center' });
    });
  }
  var compareCta = root.querySelector('.lb-compare-cta');
  if (compareCta) {
    compareCta.addEventListener('click', function (e) {
      e.preventDefault();
      var target = root.querySelector('.lb-cod-wrap') || root.querySelector('.lb-cta-fallback');
      if (target) target.scrollIntoView({ block: 'center' });
    });
  }
});
